import { render, staticRenderFns } from "./eliminatecancel.vue?vue&type=template&id=45ea5744&scoped=true"
import script from "./eliminatecancel.vue?vue&type=script&lang=js"
export * from "./eliminatecancel.vue?vue&type=script&lang=js"
import style0 from "./eliminatecancel.vue?vue&type=style&index=0&id=45ea5744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea5744",
  null
  
)

export default component.exports